var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-radio',_vm._b({model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'b-form-radio',{ ..._vm.schema, ..._vm.schema.attributes },false),[_vm._v(_vm._s(_vm.schema.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }